import React from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { Button, ErrorDetail, Input } from '@/ui/components'
import { strings } from './Authentication.strings'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

interface FormData {
  username: string
  password: string
  confirm: string
}

interface Props {
  createAccount: (data: Omit<FormData, 'confirm'>) => void
  loading?: boolean
  error?: Error | null
}

export const CreateAccountForm: React.FC<Props> = ({
  createAccount,
  loading,
  error,
}) => {
  const intl = useIntl()
  const {
    register,
    handleSubmit,
    // formState: { errors }, // TODO: Connect form errors
  } = useForm<FormData>()

  const onSubmission = handleSubmit((data) => {
    if (data.password !== data.confirm) {
      console.error('Passwords needs to match')
      // throw error
      return
    }
    createAccount({ username: data.username, password: data.password })
  })

  return (
    <Form onSubmit={onSubmission}>
      <h2>
        <FormattedMessage {...strings.createAccountTitle} />
      </h2>
      <Input
        type="email"
        label={intl.formatMessage(strings.emailLabel)}
        placeholder={intl.formatMessage(strings.emailPlaceholder)}
        {...register('username')}
        autoComplete="username"
        required
        disabled={loading}
      />
      <Input
        type="password"
        label={intl.formatMessage(strings.passwordLabel)}
        placeholder={intl.formatMessage(strings.passwordPlaceholder)}
        {...register('password')}
        autoComplete="current-password"
        required
        disabled={loading}
      />
      <Input
        type="password"
        label={intl.formatMessage(strings.confirmPasswordLabel)}
        placeholder={intl.formatMessage(strings.passwordPlaceholder)}
        {...register('confirm')}
        autoComplete="current-password"
        required
        disabled={loading}
      />
      <Button disabled={loading}>
        <FormattedMessage {...strings.createAccountBtn} />
      </Button>
      {error ? <ErrorDetail error={'Error creating account'} /> : null}
    </Form>
  )
}
